
<template>

  <!-- Edit Schedule Modal -->
  <div :id="id" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Schedule <span v-if="Shift.date">({{ formatDate(Shift.date) }})</span></h5>
          <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="Shift.updated_by_user || Shift.updated_by || Shift.updated_at" class="alert alert-info py-2 px-3 mb-3 d-flex align-items-center" style="font-size: 0.85rem;">
            <i class="fas fa-info-circle me-2"></i>
            <div>
              <span>Last updated </span>
              <span v-if="Shift.updated_by_user">
                by <strong>{{ Shift.updated_by_user.first_name }} {{ Shift.updated_by_user.last_name }}</strong>
              </span>
              <span v-else-if="Shift.updated_by">
                by <strong>User #{{ Shift.updated_by }}</strong>
              </span>
              <span v-if="Shift.updated_at">
                at <strong>{{ formatDateTime(Shift.updated_at) }}</strong>
              </span>
            </div>
          </div>
          <form @submit.prevent="updateUserSchedule()">
            <div class="row">
              <div class="col-sm-12">
                <div class="input-block mb-3">
                  <label class="col-form-label">Working Day</label>
                  <div class="form-check form-switch">
                    <input type="checkbox"  class="form-check-input" v-model="Shift.is_working" id="customSwitch4"/>
                    <label class="form-check-label" for="customSwitch4"></label>
                    <!-- v-model="Shift.is_working" :value="Shift.is_working" -->
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-item-center">
              <p>Schedule Shift</p>

              <span @click="addScheduleShift()"><i class="fas fa-plus" ></i> Add</span>
            </div>
            <div class="row  mt-1 " v-for="(input, k) in Shift.user_schedule_shifts" :key="k">
              
              <div class="col-sm-5">
                <div class="input-block mb-3">
                  <label class="col-form-label">Start Time <span class="text-danger">*</span></label>
                  <div class="input-group time">
                    <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'from_time')" v-model="input.from_time" class="form-control timepicker" placeholder="00:00:00" />
                    <!-- <span class="input-group-text"><i class="fa-regular fa-clock"></i></span> -->
                  </div>
                </div>
              </div>


              <div class="col-sm-5">
                <div class="input-block mb-3">
                  <label class="col-form-label">End Time <span class="text-danger">*</span></label>
                  <div class="input-group time">
                    <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'to_time')" v-model="input.to_time" class="form-control timepicker" placeholder="00:00:00" />
                    <!-- <span class="input-group-text"><i class="fa-regular fa-clock"></i></span> -->
                  </div>
                </div>
              </div>
              <div class="col-sm-2 top-margin text-center" v-if="k > 0"><span @click="removeScheduleShift(k)"><i class="fas fa-trash" ></i></span></div>
              
            </div>
            <div class="d-flex justify-content-between align-item-center mt-3">
              <p>Schedule break</p>
              <span @click="addScheduleBreak()"><i class="fas fa-plus" ></i> Add</span>
            </div>
            <div class="row  mt-1" v-for="(input, k) in Shift.user_schedule_break_conditions" :key="k">
              <div class="col-sm-5">
                <div class="input-block mb-3">
                  <label class="col-form-label">Work Hour<span class="text-danger">*</span></label>
                  <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'work_hours')" v-model="input.work_hours" class="form-control timepicker" placeholder="00:00:00" />
                </div>
              </div>
              <div class="col-sm-5">
                <div class="input-block mb-3">
                  <label class="col-form-label">Break<span class="text-danger">*</span></label>
                  <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'break_hours')" v-model="input.break_hours" class="form-control timepicker" placeholder="00:00:00" />
                </div>
              </div>
              <div class="col-sm-2 top-margin text-center" v-if="k > 0"><span @click="removeScheduleBreak(k)"><i class="fas fa-trash" ></i></span></div>
            </div>


            <div class="submit-section">
              <button type="submit" class="btn btn-primary submit-btn" >
                <span v-if="!loader">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Schedule Modal -->
</template>

<script>
import { ref } from "vue";
import axios from 'axios';
import {VUE_APP_API_BASE_URL} from "../../config";
import { timeInputMixin } from "../../mixins/timeInputMixin";
import { formatDayDateMonthYear, formatDateTimeStandardWithTime } from "../../utils/util-funcitons";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  mixins: [timeInputMixin],
  props: {
    id: {
      type: String,
      default: 'edit_schedule'
    }
  },
  data() {
    return {
      userData:'',
      scheduleId:'',
      user_schedule_data_id:'',
      loader: false,
      value: null,
      value1: null,
      value2: null,
      value3: null,
      value4: null,
      value5: null,
      value6: null,
      value17: null,
      value18: null,
      value19: null,
      value20: null,
      value21: null,
      value22: null,
      value23: null,
      Shift: {
        "is_working": true,
        "user_schedule_shifts": [
          {
            "from_time": '00:00:00',
            "to_time": '00:00:00'
          }
        ],
        "user_schedule_break_conditions": [
          {
            "work_hours": '00:00:00',
            "break_hours": '00:00:00'
          }
        ]
      },
      startdate: currentDate,
      dateFormat: 'dd-MM-yyyy',
      startdateone: currentDateOne,
      RepeatOne: ["1", "2", "3", "4", "5", "6"],
      
    };
  },
  mounted(){
    
  },
  methods: {
     convertMinutesToHours(minutes) {
      var num = Number(minutes) || 0;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minute = (hours - rhours) * 60;
      var rminutes = Math.round(minute);
      var paddedHours = rhours.toString().padStart(2, '0');
      var paddedMinutes = rminutes.toString().padStart(2, '0');
      return paddedHours + ":" + paddedMinutes + ":00";
    },



    addScheduleShift() {
      this.Shift['user_schedule_shifts'].push({
        from_time: '00:00:00',
        to_time: '00:00:00'
      });
    },
    removeScheduleShift(index) {
      this.Shift['user_schedule_shifts'].splice(index, 1);
    },
    addScheduleBreak() {
      this.Shift['user_schedule_break_conditions'].push({
        "work_hours": '00:00:00',
        "break_hours": '00:00:00'
      });
    },
    removeScheduleBreak(index) {
      this.Shift['user_schedule_break_conditions'].splice(index, 1);
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      return formatDateTimeStandardWithTime(datetime);
    },
    formatDate(date) {
      if (!date) return '';
      const parts = date.split('/');
      if (parts.length === 3) {
        const isoDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        return formatDayDateMonthYear(isoDate);
      }
      return formatDayDateMonthYear(date);
    },
    updateValues(record){
        this.userData = record;
        // this.user_schedule_data_id = user_schedule_data.user_schedule_id
        console.log(this.userData)
        this.getUserSchedule();
    },
    getUserSchedule(){
        // axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/${this.userId}/get-schedule`)
        // .then((response) => {
          if (this.userData) {
            // const columnExists = response.data.data.some((col) => col.title === this.user_schedule_data_id);
            this.Shift = (({ id, date, is_working, user_schedule_shifts, user_schedule_break_conditions, updated_by, updated_at, updated_by_user }) => ({ id, date, is_working, user_schedule_shifts, user_schedule_break_conditions, updated_by, updated_at, updated_by_user }))(this.userData);
            this.Shift['user_schedule_shifts'].forEach(element => {
              if (!element.from_time) element.from_time = '00:00:00';
              else if (element.from_time.length === 5) element.from_time += ':00';
              if (!element.to_time) element.to_time = '00:00:00';
              else if (element.to_time.length === 5) element.to_time += ':00';
            });
            this.Shift['user_schedule_break_conditions'].forEach(element => {
              element.work_hours = this.convertMinutesToHours(element.work_hours);
              element.break_hours = this.convertMinutesToHours(element.break_hours);
            });
            this.Shift['is_working'] = this.Shift['is_working'] === 1 ? true : false;
            this.scheduleId = this.Shift.id;
          }
          // } else {
          //   this.$toast.error(response.data.message)
          //   // this.errorMessage = response.data.message ?? "";
          // }
        // })
        // .finally(() => {
        // });

    },
    updateUserSchedule(){
      this.loader = true;
      axios.post(`${VUE_APP_API_BASE_URL}/user-schedule/${this.scheduleId}/update`, this.Shift)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$emit("editedShift");
            this.$refs.Close.click();
            this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
           this.loader = false;
        });
          
    }
  }
};
</script>

<style scoped>
.top-margin{
    margin-top: 2.2rem !important;
}
</style>
